
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Prompt, Redirect } from 'react-router';
import { Button, Row, Col, ButtonToolbar, ButtonGroup, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown, Nav, NavItem, NavLink } from 'reactstrap';
import { Formik, Field, Form } from 'formik';
import DocumentTitle from 'react-document-title';
import classNames from 'classnames';
import LoadingIcon from 'mdi-react/LoadingIcon';
import CheckIcon from 'mdi-react/CheckIcon';
import DatePicker from '../../components/custom/DatePicker';
import NaviBar from '../../components/custom/NaviBar';
import DropdownField from '../../components/custom/DropdownField';
import AutoCompleteField from '../../components/custom/AutoCompleteField';
import RintagiScreen from '../../components/custom/Screen';
import ModalDialog from '../../components/custom/ModalDialog';
import EyeIcon from 'mdi-react/EyeIcon';
import queryString from 'query-string'
import { showNotification } from '../../redux/Notification';
import { registerBlocker, unregisterBlocker } from '../../helpers/navigation'
import { isEmptyId, getAddDtlPath, getAddMstPath, getEditDtlPath, getEditMstPath, getNaviPath, getDefaultPath, isEmailFormat, isNotEmpty } from '../../helpers/utils'
import { toMoney, toLocalAmountFormat, toLocalDateFormat, toDate, strFormat } from '../../helpers/formatter';
import { setTitle, setSpinner, setTopbarMenu, hideSidebar, hideTopbarMenu, registerTopbarLeft } from '../../redux/Global';
import { RememberCurrent, GetCurrent } from '../../redux/Persist'
import { getNaviBar } from './index';
import SubTestReduxObj from '../../redux/SubTest';
import Skeleton from 'react-skeleton-loader';
import ControlledPopover from '../../components/custom/ControlledPopover';
import log from '../../helpers/logger';
import { flushAccountInfo, loadPage, submitAccountInfo } from '../../redux/AccountInfo';
import { login, logout, getCurrentUser, changePassword, ShowSpinner } from '../../redux/Auth';
import VwRUsrSubDtlReduxObj, { ShowMstFilterApplied } from '../../redux/VwRUsrSubDtl';

class ChangePassword extends RintagiScreen {
  constructor(props) {
    super(props);

    this.state = {
      ScreenButton: null,
      initialing: true,
      Buttons: {},
      showPassword: false,
      j: '',
      p: '',
      key: Date.now(),
      ModalColor: "",
      ModalTitle: "",
      ModalHeader: false,
      ModalMsg: '',
      ModalOpen: false,
      ModalSuccess: null,
      submitting: false,
      isMobile: false,
    }

    this.GetReduxState = () => (this.props.SubTest || {});
    this.blocker = null;
    this.titleSet = false;
    this.MstKeyColumnName = 'subTestId2';
    this.SystemName = 'Rintagi';
    this.confirmUnload = this.confirmUnload.bind(this);
    this.hasChangedContent = false;
    this.setDirtyFlag = this.setDirtyFlag.bind(this);
    this.AutoCompleteFilterBy = (option, props) => { return true };
    this.OnModalReturn = this.OnModalReturn.bind(this);
    this.mobileView = window.matchMedia('(max-width: 1200px)');
    this.mediaqueryresponse = this.mediaqueryresponse.bind(this);

    this.props.setSpinner(true);

    this.showPassword = this.showPassword.bind(this);
    this.changePassword = this.changePassword.bind(this);

    this.props.registerTopbarLeft("","",true,"","");
    this.props.hideSidebar(false);
    this.props.hideTopbarMenu(false);

    // flushAccountInfo();

    // this.props.setTopbarMenu(true);

    if (!this.props.suppressLoadPage && this.props.history) {
      RememberCurrent('LastAppUrl', (this.props.history || {}).location, true);
    }
  }

  mediaqueryresponse(value) {
    if (value.matches) { // if media query matches
      this.setState({ isMobile: true });
    }
    else {
      this.setState({ isMobile: false });
    }
  }

  subUsrId2InputChange() { const _this = this; return function (name, v) { const filterBy = ''; _this.props.SearchsubUsrId2(v, filterBy); } }/* ReactRule: Master Record Custom Function */
  /* ReactRule End: Master Record Custom Function */

  showPassword(e) {
    e.preventDefault();
    this.setState({
      showPassword: !this.state.showPassword,
      submitting: false,
    })
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.submitting) {
      prevState.setSubmitting(false);
    }
    return null;
  }

  changePassword(values, { setSubmitting, setFieldValue, setFieldTouched, setErrors, resetForm, setValues /* setValues and other goodies */ }) {
    this.setState({ submitting: true, setSubmitting: setSubmitting });
    console.log(values);

    this.props.changePassword(
      {
        j: this.state.j || '',
        p: this.state.p || '',
        newUsrPassword: values.cNewUsrPassword,
        confirmPwd: values.cConfirmPwd,
      }
    )
  }

  confirmUnload(message, callback) {
    const SubTestState = this.props.SubTest || {};
    const auxSystemLabels = SubTestState.SystemLabel || {};
    const confirm = () => {
      callback(true);
    }
    const cancel = () => {
      callback(false);
    }
    this.setState({ ModalOpen: true, ModalSuccess: confirm, ModalCancel: cancel, ModalColor: 'danger', ModalTitle: auxSystemLabels.UnsavedPageTitle || '', ModalMsg: message });
  }

  setDirtyFlag(dirty) {
    /* this is called during rendering but has side-effect, undesirable but only way to pass formik dirty flag around */
    if (dirty) {
      if (this.blocker) unregisterBlocker(this.blocker);
      this.blocker = this.confirmUnload;
      registerBlocker(this.confirmUnload);
    }
    else {
      if (this.blocker) unregisterBlocker(this.blocker);
      this.blocker = null;
    }
    if (this.props.updateChangedState) this.props.updateChangedState(dirty);
    this.SetCurrentRecordState(dirty);
    return true;
  }

  componentDidMount() {
    // this.mediaqueryresponse(this.mobileView);
    // this.mobileView.addListener(this.mediaqueryresponse) // attach listener function to listen in on state changes
    // const isMobileView = this.state.isMobile;
    // const useMobileView = (isMobileView && !(this.props.user || {}).desktopView);
    // const suppressLoadPage = this.props.suppressLoadPage;
    // if (!suppressLoadPage) {
    //   const { mstId } = { ...this.props.match.params };
    //   if (!(this.props.SubTest || {}).AuthCol || true) {
    //     this.props.LoadPage('Mst', { mstId: mstId || '_' });
    //   }
    // }
    // else {
    //   return;
    // }

    const { mstId } = { ...this.props.match.params };
    if (!(this.props.SubTest || {}).AuthCol || true) {
      this.props.LoadPage('Mst', { mstId: mstId || '_' });
    }
    if (!(this.props.VwRUsrSubDtl || {}).AuthCol || true) {
      this.props.LoadUserPage('SearchList', { mstId: mstId || '_' });
      this.props.LoadUserInitPage({ keyId: null });
    }

    const qs = queryString.parse(this.props.location.search);

    this.setState({
      j: qs.j,
      p: qs.p,
    });
  }

  componentDidUpdate(prevProps, prevStates) {
    const emptyTitle = '';
    const siteTitle = this.SystemName;

    if (!this.titleSet) {
      this.props.setTitle(siteTitle);
      this.titleSet = true;
    }

    if (this.props.global.pageSpinner) {
      const _this = this;
      setTimeout(() => _this.props.setSpinner(false), 500);
    }

    // setTimeout(() => {
    //   log.debug('#######1');
    //   log.debug(this.props.auth.pass_success);
    //   if(this.props.auth.pass_success) {
    //     log.debug('#######2');
    //     this.props.history.push('/account-settings');
    //   }
    // }, 0);

    const currentReduxObj = this.props.auth || {};
    const previousReduxObj = prevProps.auth || {};

    if (this.state.submitting && !currentReduxObj.loading) {

      log.debug('##### 1');

      this.state.setSubmitting(false);
      if (currentReduxObj.status !== "failed") {
        log.debug('##### 2');
        this.redirecting = true; // Control redirection
        setTimeout(() => {
          if (this.redirecting) {
            if (this.props.auth.pass_success) {
              log.debug('##### 3');
              this.props.history.push('/account-settings');
              setTimeout(() => { this.props.setSpinner(false) }, 0);
            }
          }
          else {
            this.props.setSpinner(false);
          }
        }, 0);
      }
      else {
        this.setState({ submitting: false });
        this.props.setSpinner(false);
      }
    }
  }

  componentWillUnmount() {
    if (this.blocker) {
      unregisterBlocker(this.blocker);
      this.blocker = null;
    }
    this.mobileView.removeListener(this.mediaqueryresponse);
  }


  render() {
    const SubTestState = this.props.SubTest || {};

    if (SubTestState.access_denied) {
      return <Redirect to='/error' />;
    }

    const screenHlp = SubTestState.ScreenHlp;

    // Labels
    const siteTitle = (this.props.global || {}).pageTitle || '';
    log.debug(siteTitle);
    const MasterRecTitle = ((screenHlp || {}).MasterRecTitle || '');
    const MasterRecSubtitle = ((screenHlp || {}).MasterRecSubtitle || '');

    const screenButtons = SubTestReduxObj.GetScreenButtons(SubTestState) || {};
    const itemList = SubTestState.Dtl || [];
    const auxLabels = SubTestState.Label || {};
    const auxSystemLabels = SubTestState.SystemLabel || {};

    const columnLabel = SubTestState.ColumnLabel || {};
    const authCol = this.GetAuthCol(SubTestState);
    const authRow = (SubTestState.AuthRow || [])[0] || {};
    const currMst = ((this.props.SubTest || {}).Mst || {});
    const currDtl = ((this.props.SubTest || {}).EditDtl || {});
    const naviBar = getNaviBar('Mst', currMst, currDtl, screenButtons).filter(v => ((v.type !== 'Dtl' && v.type !== 'DtlList') || currMst.subTestId2));
    const selectList = SubTestReduxObj.SearchListToSelectList(SubTestState);
    const selectedMst = (selectList || []).filter(v => v.isSelected)[0] || {};
    const subTestId2 = currMst.subTestId2;
    const subTestDesc2 = currMst.subTestDesc2;
    const subDate2 = currMst.subDate2;
    const subUsrId2List = SubTestReduxObj.ScreenDdlSelectors.subUsrId2(SubTestState);
    const subUsrId2 = currMst.subUsrId2;

    const { dropdownMenuButtonList, bottomButtonList, hasDropdownMenuButton, hasBottomButton, hasRowButton } = this.state.Buttons;
    const hasActableButtons = hasBottomButton || hasRowButton || hasDropdownMenuButton;

    const isMobileView = this.state.isMobile;
    const useMobileView = (isMobileView && !(this.props.user || {}).desktopView);
    /* ReactRule: Master Render */
    /* ReactRule End: Master Render */

    const reduxObj = this.props.auth || {};

    return (
      <DocumentTitle title={siteTitle}>
        <div>
          <ModalDialog color={this.state.ModalColor} title={this.state.ModalTitle} onChange={this.OnModalReturn} ModalOpen={this.state.ModalOpen} message={this.state.ModalMsg} />
          <div className='account'>
            <div className='account__wrapper account-left'>
              <div className='account__card'>
                <div>
                  <div className="account-narrow-left">
                    <div className='account__head mb-20'>
                      <h3 className='project-title mb-20'>Change Password</h3>
                    </div>
                    <div className='w-100'>
                      <Formik
                        initialValues={{
                          cNewUsrPassword: '',
                          cConfirmPwd: '',
                        }}
                        key={this.state.key}
                        validate={values => {
                          // // same as above, but feel free to move this into a class method now.
                          let errors = {};
                          if (!values.cNewUsrPassword) {
                            errors.cNewUsrPassword = this.props.auth.Label.NewUsrPasswordEmpty;
                          }
                          if (values.cNewUsrPassword !== values.cConfirmPwd) {
                            errors.cConfirmPwd = this.props.auth.Label.ConfirmPwdEmpty;
                          }
                          // if (!values.email) {
                          // //   errors.email = 'This field is required';
                          // // } else
                          // if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
                          //   errors.email = 'Invalid email address';
                          // }
                          return errors;
                        }}
                        onSubmit={this.changePassword}
                        render={({
                          values,
                          errors,
                          touched,
                          isSubmitting,
                          dirty,
                          setFieldValue,
                          setFieldTouched,
                          handleChange,
                          submitForm,
                          setFieldError,
                        }) => (
                            <div>
                              {/* {this.setDirtyFlag(dirty) &&
                                <Prompt
                                  when={dirty}
                                  message={auxSystemLabels.UnsavedPageMsg || ''}
                                />
                              } */}
                              <Form className='form'>
                                <div className='w-100'>
                                  <div className='form__form-group'>
                                    <label className='form__form-group-label'>{this.props.auth.Label.NewuserPassword}</label>
                                    <div className='form__form-group-field'>
                                      <Field
                                        type={this.state.showPassword ? 'text' : 'password'}
                                        name="cNewUsrPassword"
                                        className="btrr-0 bbrr-0 brc-t"
                                        onChange={this.TextChange(setFieldValue, setFieldTouched, "cNewUsrPassword")}
                                        // onClick={this.TextFocus}
                                        value={values.cNewUsrPassword}
                                      />
                                      <div className='form__form-group-icon-custom pt-5 pointer' onClick={(e) => this.showPassword(e)}><i className="mdi mdi-eye icon-form-right"></i></div>
                                    </div>
                                    {errors.cNewUsrPassword && touched.cNewUsrPassword && <span className='form__form-group-error'>{errors.cNewUsrPassword}</span>}
                                  </div>
                                  <div className='form__form-group'>
                                    <label className='form__form-group-label'>{this.props.auth.Label.ConfirmPwd}</label>
                                    <div className='form__form-group-field'>
                                      <Field
                                        type={this.state.showPassword ? 'text' : 'password'}
                                        name="cConfirmPwd"
                                        className="btrr-0 bbrr-0 brc-t"
                                        onChange={this.TextChange(setFieldValue, setFieldTouched, "cConfirmPwd")}
                                        // onClick={this.TextFocus}
                                        value={values.cConfirmPwd}
                                      />
                                      <div className='form__form-group-icon-custom pt-5 pointer' onClick={(e) => this.showPassword(e)}><i className="mdi mdi-eye icon-form-right"></i></div>
                                    </div>
                                    {errors.cConfirmPwd && touched.cConfirmPwd && <span className='form__form-group-error'>{errors.cConfirmPwd}</span>}
                                  </div>
                                  <Row className="row-75 mt-30">
                                    <Col xs={6} className="col-75">
                                      <Button
                                        color="success"
                                        type='button'
                                        outline
                                        className="btn btn-outline-success rounded account__btn"
                                        onClick={() => { this.props.history.push('/account-settings') }}>
                                        Cancel
                                  </Button>
                                    </Col>
                                    <Col xs={6} className="col-75">
                                      <Button
                                        color="success"
                                        type='submit'
                                        disabled={isSubmitting || reduxObj.loading}
                                        className="btn btn-success rounded account__btn"
                                        onClick={this.SubmitForm()}>
                                        {this.props.auth.Label.pdPwdBtn}
                                      </Button>
                                    </Col>
                                  </Row>
                                </div>
                              </Form>
                            </div>
                          )}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </DocumentTitle>
    );
  };
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  user: (state.auth || {}).user,
  error: state.error,
  SubTest: state.SubTest,
  global: state.global,
  VwRUsrSubDtl: state.VwRUsrSubDtl,
});

const mapDispatchToProps = (dispatch) => (
  bindActionCreators(Object.assign({},
    { LoadPage: SubTestReduxObj.LoadPage.bind(SubTestReduxObj) },
    { LoadUserPage: VwRUsrSubDtlReduxObj.LoadPage.bind(VwRUsrSubDtlReduxObj) },
    { LoadUserInitPage: VwRUsrSubDtlReduxObj.LoadInitPage.bind(VwRUsrSubDtlReduxObj) },
    { SavePage: SubTestReduxObj.SavePage.bind(SubTestReduxObj) },
    { DelMst: SubTestReduxObj.DelMst.bind(SubTestReduxObj) },
    { AddMst: SubTestReduxObj.AddMst.bind(SubTestReduxObj) },
    //    { SearchMemberId64: SubTestReduxObj.SearchActions.SearchMemberId64.bind(SubTestReduxObj) },
    //    { SearchCurrencyId64: SubTestReduxObj.SearchActions.SearchCurrencyId64.bind(SubTestReduxObj) },
    //    { SearchCustomerJobId64: SubTestReduxObj.SearchActions.SearchCustomerJobId64.bind(SubTestReduxObj) },
    { SearchsubUsrId2: SubTestReduxObj.SearchActions.SearchsubUsrId2.bind(SubTestReduxObj) },
    { showNotification: showNotification },
    { setTitle: setTitle },
    { setSpinner: setSpinner },
    { setTopbarMenu: setTopbarMenu },
    { hideSidebar: hideSidebar },
    { hideTopbarMenu: hideTopbarMenu },
    { getCurrentUser: getCurrentUser },
    { changePassword: changePassword },
    { registerTopbarLeft: registerTopbarLeft },
  ), dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);




// WEBPACK FOOTER //
// ./src/pages/Custom/ChangePassword.js